module.exports = __webpack_public_path__ + "4-76.jpg?7ef43a6363145ee793abe13be23a4844";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-76.jpg
// module id = 157
// module chunks = 0